<template lang="pug">
.container-tags(v-if="tags.length")
  .tag(v-for="tag in tags" :key="tag.id")
    span {{ tag.name }}
</template>

<script>
export default {
  name: "Tags",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.container-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .tag {
    padding: 2px 10px;
    border: 1px solid $borderColor;
    box-sizing: border-box;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
  }
}
</style>